import { itemToAnalyticsItem, useCart } from "~/hooks/useCart";
import Button from "./common";

export interface Props {
  translucentEffect?: boolean;
  isSearchVisible?: boolean;
}

function CartButton({ translucentEffect, isSearchVisible }: Props) {
  const { loading, cart } = useCart();
  const {
    totalizers = [],
    items = [],
    marketingData,
    storePreferencesData,
  } = cart.value ?? {};
  const coupon = marketingData?.coupon ?? undefined;
  const currency = storePreferencesData?.currencyCode ?? "BRL";
  const total = totalizers.find((item) => item.id === "Items")?.value ?? 0;
  const discounts =
    (totalizers.find((item) => item.id === "Discounts")?.value ?? 0) * -1;

  return (
    <Button
      aria-label="Abrir carrinho"
      currency={currency}
      loading={loading.value}
      total={(total - discounts) / 100}
      translucentEffect={translucentEffect}
      isSearchVisible={isSearchVisible}
      items={items.map((item, index) =>
        itemToAnalyticsItem({ ...item, coupon }, index)
      )}
    />
  );
}

export default CartButton;
